//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
      show: false,
    };
  },
  
  props: {
    title: {
      type: String,
      default: 'This is a News Listing Item',
    },
    permalink: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'one',
    },
    background: {
      default: require('../../images/dummy_image.jpg'), 
    },
  },
  
  computed: {
    styles: function() {
      return {
        'background-image': 'url(' + this.background + ')',
      };
    },
  },
  
  watch: {

  },
  
  methods: {
    mouseover: function(){
      this.show = true
    },    
    mouseleave: function(){
      this.show = false
    },
  },
  
  components: {
  },
  
  created() {
    
  },
  mounted() {
  },
};




// WEBPACK FOOTER //
// ./scripts/vue/NewsListingItem.vue